import { OptionalFeature } from "../../../../base/domain/drawing";
import { ITextSearchBehavior } from "./ITextSearchBehavior";

export class TextSearchBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean     = false,
  ) {
    super(isEnable);
  }

  clone(): TextSearchBehavior {
    return new TextSearchBehavior(this.isEnable);
  }

  static from(source: ITextSearchBehavior): TextSearchBehavior {
    return new TextSearchBehavior(source.isEnable);
  }

  static to(source: TextSearchBehavior): ITextSearchBehavior {
    return {
      isEnable: source.isEnable,
    };
  }
}
